// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
import SettingsAutomationFlows from "./SettingsAutomationFlows";

import {
  DashboardPage,
  ReservationsHub,
  RedirectPage,
  SettingsHotelInfo,
  SettingsHotelTimes,
  SettingsRoomsAreas,
  SettingsUsers,
  SettingsRoomTypes,
  SettingsUpsell,
  GuestDetails,
  SettingsPms,
  SettingsIntegrations,
  SettingsCheckin,
  SettingsCheckinFlow,
  RegistrationCard,
  SettingsTrainingData,
  SettingsTrainingDataStaff,
  AskAI,
  SettingsAdmin,
  HousekeepingPage,
  SettingsWhitelabel,
  CurrentPasscodes,
  UnlockRecords,
  SettingsBilling,
  GatewaysPage,
  GatewayDetails,
  AIBriefPage,
  ConversationsPage,
} from "./";

const routes = {
  path: "",
  component: DashboardPage,
  childRoutes: [
    { path: "", component: AIBriefPage, isIndex: true },
    { path: "redirect-guests", component: RedirectPage },
    { path: "redirect-expected", component: RedirectPage },
    { path: "redirect-messages", component: RedirectPage },
    { path: "expected", component: ReservationsHub },
    { path: "guests", component: ReservationsHub },
    { path: "guests-all", component: ReservationsHub },
    { path: "conversations", component: ConversationsPage },
    { path: "archived", component: ReservationsHub },
    { path: "expected/:guestId", component: GuestDetails },
    { path: "guests/:guestId", component: GuestDetails },
    { path: "archived/:guestId", component: GuestDetails },
    { path: "expected/:guestId/:tab", component: GuestDetails },
    { path: "guests/:guestId/:tab", component: GuestDetails },
    { path: "archived/:guestId/:tab", component: GuestDetails },
    { path: "settings", component: SettingsHotelInfo },
    { path: "settings/info", component: SettingsHotelInfo },
    { path: "settings/times", component: SettingsHotelTimes },
    { path: "settings/info", component: SettingsHotelTimes },
    { path: "settings/doors", component: SettingsRoomsAreas },
    { path: "settings/users", component: SettingsUsers },
    { path: "settings/roomtypes", component: SettingsRoomTypes },
    { path: "settings/upsell", component: SettingsUpsell },
    { path: "settings/checkin", component: SettingsCheckin },
    { path: "settings/checkin-flow", component: SettingsCheckinFlow },
    { path: "settings/automation-flows", component: SettingsAutomationFlows },
    { path: "settings/admin", component: SettingsAdmin },
    { path: "settings/whitelabel", component: SettingsWhitelabel },
    { path: "settings/billing", component: SettingsBilling },
    { path: "settings/pms", component: SettingsPms },
    { path: "settings/upsell-integrations", component: SettingsIntegrations },
    { path: "settings/training", component: SettingsTrainingData },
    { path: "settings/training-staff", component: SettingsTrainingDataStaff },
    { path: "askai", component: AskAI },
    { path: "/pdf/:guestId", component: RegistrationCard },
    { path: "current-passcodes", component: CurrentPasscodes },
    { path: "unlock-records", component: UnlockRecords },
    { path: "housekeeping", component: HousekeepingPage },
    { path: "gateways", component: GatewaysPage },
    { path: "gateways/:gatewayId", component: GatewayDetails },
    { path: ":guestId", component: GuestDetails },
  ],
};

export default routes;
